export const setCookie = (name, value) => {
  try {
    if (!value) {
      return;
    }
    document.cookie = name + "=" + (value || "") + "; path=/";
  } catch (error) {
    console.error(`Error setting cookie ${name}:`, error);
  }
};

export const getCookie = (name) => {
  try {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  } catch (error) {
    console.error(`Error getting cookie ${name}:`, error);
    return null;
  }
};

export const deleteCookie = (name) => {
  try {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  } catch (error) {
    console.error(`Error deleting cookie ${name}:`, error);
  }
};


export const getRedirectToken = () => {
  return getCookie("redirect");
};

export const setRedirectToken = (value) => {
  setCookie("redirect", value);
};

export const getMbServerToken = () => {
  return getCookie("mbServerToken");
};

export const setMbServerToken = (value) => {
  setCookie("mbServerToken", value);
};

export const clearAuthTokens = () => {
  deleteCookie("redirect");
  deleteCookie("mbServerToken");
};

export const getAuthTokens = () => {
  return {
    redirect: getRedirectToken(),
    mbServerToken: getMbServerToken(),
  };
};
